import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/app/widgets";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || "";
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    api.post("/auth/google/session", { session_id: sessionId })
      .then((res) => {
        setUser(res.data);
        navigate("/app", { replace: true, state: { user: res.data } });
      })
      .catch((e) => {
        toast.error(apiError(e));
        navigate("/login", { replace: true });
      });
  }, [location.hash, navigate, setUser]);

  return <Spinner label="Completing Google sign-in" />;
}
